import React, { useEffect, useMemo, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Layout from "../../Shared/Layout";
import {
    Container,
    makeStyles,
} from "@material-ui/core";
import styled from "styled-components";
import { InertiaLink, usePage } from "@inertiajs/inertia-react";
import BackButton from "../../Shared/BackButton";
import { Trans } from "../../utils/i18n";
import { Chat } from "../../Shared/Chat";
import { Step, StepLabel, Stepper } from "@material-ui/core";
import { Tab, Tabs, useMediaQuery } from "@mui/material";

const StyledContentWrapper = styled.div`
    display: flex;
`;

const StyledChatWrapper = styled.div`
    flex-basis: 33%;
    max-width: 430px;
    max-height: 100vh;
    height: fit-content;
    overflow-y: auto;
    margin-top: 30px;
    margin-left: 50px;
    padding-left: 50px;
    border-left: 1px solid #333333;
`;

const OpenInTrackTrace = styled.a`
    font-size: 14px;
    text-decoration: none;
    margin-left: 15px;
    color: ${(props) => props.theme.secondary};
    display: inline-flex;
    align-items: end;
`;

const OpenInTrackTraceIcon = styled.svg`
    height: 18px;
    margin-right: 5px;
`;

const Heading = styled.h1`
    font-size: 24px;

    @media (min-width: 800px) {
        font-size: 40px;
    }
`;

const ColumnLeft = styled.div`
    max-width: 100%;
    flex-basis: 100%;

    @media (min-width: 1000px) {
        max-width: 66.66%;
        flex-basis: 66.66%;
    }
`;

export default function Wrapper({ children }) {
    const {
        order,
        statuses,
        extendedMode,
        returnUrl,
        page,
    } = usePage().props;
    const matches = useMediaQuery("(min-width: 1000px)");
    const activeStep = statuses.findIndex(item => item.id === order.status_id);
    return (
        <Container maxWidth="lg">
            <StyledContentWrapper>
                <ColumnLeft>
                    <BackButton
                        label={
                            <Trans i18nKey="queueDetail.queues">Queues</Trans>
                        }
                        href={
                            returnUrl ||
                            route("queue.index", {
                                requesttype: order.requesttype_key,
                            })
                        }
                    />

                    <Heading>
                        <Trans i18nKey="queueDetail.jobDetail">Job Detail</Trans>: {order.number}
                        <OpenInTrackTrace
                            href={route("track.index", {
                                serialnumber: order.number,
                            })}
                            target={"_blank"}
                        >
                            <OpenInTrackTraceIcon
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="fas"
                                data-icon="external-link-alt"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                className="svg-inline--fa fa-external-link-alt fa-w-16 fa-3x"
                            >
                                <path
                                    fill="currentColor"
                                    d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                                    className=""
                                ></path>
                            </OpenInTrackTraceIcon>{" "}
                            <Trans i18nKey="queueDetail.trackTrace">
                                Track & Trace
                            </Trans>
                        </OpenInTrackTrace>
                    </Heading>

                    <Stepper
                        activeStep={Math.min(1, activeStep + 1)}
                        alternativeLabel
                    >
                        {statuses[0] && (
                            <Step active>
                                <StepLabel icon={" "}>
                                    <div style={{ fontSize: 14 }}>
                                        {statuses[0].name}
                                    </div>
                                    {/*<div style={{ fontSize: 12 }}>{ dayjs(statuses[0].updated_at).format('DD.MM.YYYY HH:mm') }</div>*/}
                                </StepLabel>
                            </Step>
                        )}
                        {statuses[1] && (
                            <Step
                                active={activeStep === 1}
                                completed={activeStep === 1}
                            >
                                <StepLabel icon={" "}>
                                    <div style={{ fontSize: 14 }}>
                                        {statuses[1].name}
                                    </div>
                                    {/*<div style={{ fontSize: 12 }}>{ dayjs(statuses[1].updated_at).format('DD.MM.YYYY HH:mm') }</div>*/}
                                </StepLabel>
                            </Step>
                        )}
                        {statuses[2] && (
                            <Step completed={false}>
                                <StepLabel icon={" "}>
                                    <div style={{ fontSize: 14 }}>
                                        {statuses[2].name}
                                    </div>
                                    {/*<div style={{ fontSize: 12 }}>{ dayjs(statuses[2].updated_at).format('DD.MM.YYYY HH:mm') }</div>*/}
                                </StepLabel>
                            </Step>
                        )}
                    </Stepper>

                    <Tabs
                        value={
                            page === "Contact"
                                ? 1
                                : page === "Product"
                                ? 2
                                : page === "History"
                                ? 3
                                : page === "Files"
                                ? 4
                                : page === "Appointments"
                                ? 5
                                : page === "Quotation"
                                ? 6
                                : page === "RepairParts"
                                ? 7
                                : page === "Payments"
                                ? 8
                                : page === "Chat"
                                ? 9
                                : 0
                        }
                        aria-label="nav tabs example"
                        textColor="secondary"
                        indicatorColor="secondary"
                        variant="scrollable"
                    >
                        <Tab
                            component={InertiaLink}
                            label={<Trans i18nKey="queueDetail.tabs.jobInformation">Job-Information</Trans>}
                            href={route("queue.details.page", {
                                order: order.order_id,
                                page: "JobInformation",
                                returnUrl,
                            })}
                        />
                        {(order.permissions.order.viewInstallationAddress ||
                            order.permissions.order.viewInvoiceAddress ||
                            order.permissions.order.viewCollectionAddress) && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.contact">Contact</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "Contact",
                                    returnUrl,
                                })}
                            />
                        )}
                        {order.permissions.product.view && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.product">Product</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "Product",
                                    returnUrl,
                                })}
                            />
                        )}
                        {order.permissions.history.viewAny && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.history">History</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "History",
                                    returnUrl,
                                })}
                            />
                        )}
                        {order.permissions.file.viewAny && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.files">Files</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "Files",
                                    returnUrl,
                                })}
                            />
                        )}
                        {order.permissions.appointment.viewAny && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.appointments">Appointments</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "Appointments",
                                    returnUrl,
                                })}
                            />
                        )}
                        {order.permissions.quotation.view && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.quotation">Quotation</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "Quotation",
                                    returnUrl,
                                })}
                            />
                        )}
                        {order.permissions.orderdetailmaterial.view && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.repairParts">Repair Parts</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "RepairParts",
                                    returnUrl,
                                })}
                            />
                        )}
                        {!matches && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.chat">Chat</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "Chat",
                                    returnUrl,
                                })}
                            />
                        )}
                        {order.permissions.payment.viewAny && (
                            <Tab
                                component={InertiaLink}
                                label={<Trans i18nKey="queueDetail.tabs.payments">Payments</Trans>}
                                href={route("queue.details.page", {
                                    order: order.order_id,
                                    page: "Payments",
                                    returnUrl,
                                })}
                            />
                        )}
                    </Tabs>

                    {children}
                </ColumnLeft>
                {!extendedMode && <div></div>}
                {extendedMode && matches && (
                    <StyledChatWrapper>
                        <h2>
                            <Trans i18nKey="queueDetail.notes">Notes</Trans>
                        </h2>
                        <Chat />
                    </StyledChatWrapper>
                )}
            </StyledContentWrapper>
        </Container>
    );
}

Wrapper.layout = (page) => <Layout children={page} />;
